import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { walletAppConfig } from './config';

export const supabase: SupabaseClient | null =
  walletAppConfig.supabaseUrl && walletAppConfig.publishableKey
    ? createClient(walletAppConfig.supabaseUrl, walletAppConfig.publishableKey, {
        auth: {
          autoRefreshToken: true,
          persistSession: true,
          detectSessionInUrl: false,
        },
        realtime: {
          params: { eventsPerSecond: 0 },
        },
      })
    : null;
